<template>
    <div class="modal fade" id="add-note" tabindex="-1" role="dialog" aria-labelledby="add-note" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title" id="forgot_ModalLabel"><i class="fa fa-plus mr-5"></i>{{'create_note' | translate}}</h4>
          </div>
          <div class="modal-body">
            <template v-if="loading">
              <div class="overlay">
                <img class="loading-gif" src="/static/img/blabla.svg"/>
              </div>
            </template>
            <div class="row pb-10" v-else>
              <div class="col-xs-12">
                <div class="form-group col-xs-3 no-padding">
                  <div class="input-group">
                    <div class="input-group-btn">
                      <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false">{{erp !== null ? erps[erp] : 'ERP'}}
                        <span class="fa fa-caret-down"></span>
                      </button>
                      <ul class="dropdown-menu">
                        <li><a href="#" @click="erp = 0">{{'all' | translate}}</a></li>
                        <li><a href="#" @click="erp = 4">HIS</a></li>
                        <li><a href="#" @click="erp = 5">BITS</a></li>
                        <li><a href="#" @click="erp = 3">ETOS</a></li>
                        <li><a href="#" @click="erp = 2">IPOS</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="form-group col-xs-9 no-padding">
                  <div class="input-group">
                    <div class="input-group-btn">
                      <select class="form-control" v-model="type">
                        <option class="normal" value="">{{'note_type' | translate}}</option>
                        <option class="normal" value="info"><i class="fa fa-info-circle mr-5"></i>{{'info_notification' | translate}}</option>
                        <option class="normal" value="warning"><i class="fa fa-warning mr-5"></i>{{'warning_notification' | translate}}</option>
                        <option class="normal" value="danger"><i class="fa fa-warning mr-5"></i>{{'alarm_notification' | translate}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>{{'title' | translate}}</label>
                  <input class="form-control" id="subject" name="subject" v-model="title" :placeholder="'title' | translate" type="text">
                </div>
                <div class="form-group">
                  <label>{{'message' | translate}}</label>
                  <vue-editor v-model="message" />
                </div>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="active"><strong>{{'is_active' | translate}}</strong>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-app btn-danger no-margin pull-left" data-dismiss="modal"><span class="fa fa-times"></span>{{'cancel' | translate}}</button>
            <button :disabled="type === '' || erp === null || loading" id="createNote" class="btn btn-app btn-success no-margin" @click="send()"><i class="fa fa-save"></i>{{'save' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default{
  name: 'Notifications',
  data () {
    return {
      message: '',
      title: '',
      loading: false,
      erps: {
        0: 'All',
        4: 'HIS',
        5: 'BITS',
        3: 'ETOS',
        2: 'IPOS'
      },
      active: 1,
      type: '',
      erp: null,
      statusCode: 'success'
    }
  },
  methods: {
    send () {
      this.loading = true
      let data = {
        title: this.title,
        message: this.message,
        is_active: this.active,
        status: this.type,
        display_to_erp: this.erp === 0 ? null : this.erp
      }
      let alert
      API.post('messages', data)
        .then(response => {
            if (response.data.id) {
              alert = {dismiss: 4, type: 'success', message: 'New message created successfully', icon: 'icon fa fa-check', show: true}
              this.$emit('response', alert)
              this.message = ''
              this.title = ''
              this.erp = null
              this.type = ''
              this.loading = false
            }
          })
        .catch(error => {
            alert = {dismiss: 4, type: 'danger', message: `There was an error: ${error.data.message}`, icon: 'icon fa fa-ban', show: true}
            this.$emit('response', alert)
            this.erp = null
            this.type = ''
            this.loading = false
        })
    }
  },
  mounted () {
  }
}
</script>
<style>
  textarea {
    background-color: transparent;
    border-color: rgba(255,255,255,.15);
    overflow: auto;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
</style>
<style scoped>
  .loading-gif {
    display: block;
    width: 30%;
    top: 42%;
    margin: 0 auto;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Monitoring/Notifications.vue